import { request } from './http.js'

export async function fetchCurrentUser() {
  const res = await fetch('/api/auth/me', { credentials: 'include' })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) return null
  return data
}

export async function login(username, password) {
  return request('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  })
}

export async function logout() {
  try {
    await request('/api/auth/logout', { method: 'POST' })
  } catch {
    // ignore logout errors
  }
}
